
import Component from 'vue-class-component';
import DocWidgetListItem2 from './DocWidgetListItem2.vue'

@Component({})
export default class DocWidgetListItem3 extends DocWidgetListItem2 {

}
